import { useContext } from 'react'
import { AuthContext} from 'app/contexts/JWTAuthContext'

export function useAuth() {
    const context = useContext(AuthContext);
  
    return context;
}
  
